import { Box } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ABAS_DO_MAPA } from '@/features/mapa/abas'
import { Mapa } from '@/features/mapa/Mapa'

/**
 * Mapa da vida, aba da ficha. A chave fica na ficha. Ocupa a tela inteira:
 * o ecomapa cabe nela sem rolar, e as outras partes rolam por dentro.
 */
export const Route = createFileRoute('/_app/app/p/$id/mapa')({
  validateSearch: z.object({ aba: z.enum(ABAS_DO_MAPA).optional() }),
  staticData: { moldura: 'larga' },
  component: function MapaDoPaciente() {
    const { id } = Route.useParams()
    const { aba } = Route.useSearch()
    return (
      <Box className="-m-2 flex min-h-0 flex-1 flex-col overflow-y-auto p-2">
        <Mapa patientId={id} aba={aba ?? 'ecomapa'} />
      </Box>
    )
  },
})
